import CardWithTitle from 'components/atoms/CardWithTitle'
import NoticeConfirmDialog from 'components/Dialog/NoticeConfirmDialog'
import useProductManagement from 'features/productManagement/useProductManagement'
import PageTable from 'pages/Analysis/HRVIndividual/PageTable'
import {
  HRV_SUMMARY_ADVANCED_ID,
  HRV_SUMMARY_ID,
} from 'pages/ProductsPages/constant'
import React, {useEffect, useMemo} from 'react'

function HRVIndividual() {
  const {getAvailableLicenses, listAvailableLicenses} = useProductManagement()

  const isShowBasicAnalysisButton = useMemo(() => {
    return Array.from(
      new Set(listAvailableLicenses.map((license) => license.packageItemId)),
    ).some((packageId) => packageId === HRV_SUMMARY_ID)
  }, [listAvailableLicenses])

  const isShowAdvancedAnalysisButton = useMemo(() => {
    return Array.from(
      new Set(listAvailableLicenses.map((license) => license.packageItemId)),
    ).some((packageId) => packageId === HRV_SUMMARY_ADVANCED_ID)
  }, [listAvailableLicenses])

  useEffect(() => {
    getAvailableLicenses()
  }, [])

  return (
    <>
      <CardWithTitle>
        <PageTable
          isShowBasicAnalysisButton={isShowBasicAnalysisButton}
          isShowAdvancedAnalysisButton={isShowAdvancedAnalysisButton}
        />
      </CardWithTitle>
      <NoticeConfirmDialog />
    </>
  )
}

export default HRVIndividual
